import { render, staticRenderFns } from "./ContactFloatingBtn.vue?vue&type=template&id=73843b50&scoped=true"
import script from "./ContactFloatingBtn.vue?vue&type=script&lang=js"
export * from "./ContactFloatingBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73843b50",
  null
  
)

export default component.exports